import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=6ef9b248&"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js&"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js&"
import style0 from "./TurnstileWidget.vue?vue&type=style&index=0&id=6ef9b248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports